
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"26","viewBox":"0 0 512 512","width":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4E6492"}},[_c('path',{attrs:{"d":"M446.604 124.392L326.608 4.395A15.067 15.067 0 00316 0H106C81.187 0 61 20.187 61 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45V135c0-4.082-1.735-7.949-4.396-10.608zM331 51.213L399.787 120H346c-8.271 0-15-6.729-15-15zM406 482H106c-8.271 0-15-6.729-15-15V45c0-8.271 6.729-15 15-15h195v75c0 24.813 20.187 45 45 45h75v317c0 8.271-6.729 15-15 15z"}}),_c('path',{attrs:{"d":"M346 212H166c-8.284 0-15 6.716-15 15v180c0 8.284 6.716 15 15 15h180c8.284 0 15-6.716 15-15V227c0-8.284-6.716-15-15-15zm-165 90h60v30h-60zm90 0h60v30h-60zm60-30h-60v-30h60zm-90-30v30h-60v-30zm-60 120h60v30h-60zm90 30v-30h60v30z"}})])])
          )
        }
      }
    